import type { Path } from '@exam-management/router';
import { Button, CalendarTodayOutlinedIcon, Flex, OpenInNewIcon, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

interface ViewDetailsButtonProps {
  url: Path;
  taskId: string;
  subtaskId: string;
}

function ViewDetailsButton(props: ViewDetailsButtonProps) {
  const { url, taskId, subtaskId } = props;

  const path = url
    .replace(':taskId', encodeURIComponent(taskId))
    .replace(':subTaskId', encodeURIComponent(subtaskId));
  return (
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      sx={{ ml: 'auto' }}
      startIcon={<OpenInNewIcon />}
      href={path}
      target='_blank'
    >
      View Details
    </Button>
  );
}

export interface QSetReviewHistoryCardItemProps {
  taskId: string;
  subtaskId: string;
  assigneeName: string;
  assignedAt: Date;
  submittedAt: Date | null;
  detailsPath?: Path;
}

export default function QSetReviewHistoryCardItem(props: Readonly<QSetReviewHistoryCardItemProps>) {
  const { taskId, subtaskId, assigneeName, assignedAt, submittedAt, detailsPath } = props;
  return (
    <Flex
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(4),
        border: `1px solid ${theme.palette.grey[300]}`,
        p: theme.spacing(4),
        position: 'relative',
        ':before': {
          content: "''",
          width: '4px',
          backgroundColor: theme.palette.primary.main,
        },
        alignItems: 'center',
      })}
    >
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(3),
        })}
      >
        <Text variant='body1Semibold'>{assigneeName}</Text>
        <Flex sx={(theme) => ({ gap: theme.spacing(4), color: theme.palette.text.secondary })}>
          <Text
            variant='body2'
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing(1),
            })}
          >
            <CalendarTodayOutlinedIcon sx={{ fontSize: '16px' }} />
            Assignment Date: {formatDateTime(assignedAt)}
          </Text>
          <Text
            variant='body2'
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing(1),
            })}
          >
            <CalendarTodayOutlinedIcon sx={{ fontSize: '16px' }} />
            Submitted Date: {submittedAt ? formatDateTime(submittedAt) : '-'}
          </Text>
        </Flex>
      </Flex>
      {detailsPath ? (
        <ViewDetailsButton url={detailsPath} taskId={taskId} subtaskId={subtaskId} />
      ) : null}
    </Flex>
  );
}
